import React from "react";
import { Button } from "@material-ui/core";

const CallEndedButton = () => {
  const handleCallEnded = () => {
    window.location.href = "/call-ended";
  };

  return (
    <Button
      id="iconnect-call-ended-button"
      onClick={handleCallEnded}
      style={{
        display: "none", // Hidden by default
        position: "absolute",
        top: "-9999px",
        left: "-9999px",
        visibility: "hidden",
        opacity: 0,
        pointerEvents: "none",
      }}
    >
      Call Ended
    </Button>
  );
};

export default CallEndedButton;
